<script>
  export let label = "Unlabeled";
  export let disabled = false;
  export let clickfn = () => {
    
  };;

</script>
<button class:disabled={disabled} on:click={clickfn}>
{label}
</button>

<style>
  button {
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    padding: 1.2rem 1rem;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #666; 
    cursor: pointer;
  }

  .disabled {
    background-color: #F5F5F7;
    color: #AEB0BC;
    border: none;
    box-shadow: none;
  }

</style>